export type PaymentDocumentData = {
  id: number;
  paymentDocumentId: number;
  contractPaymentId: number;
  date: string;
  amount: number;
  studentId: string;
  studentName: string;
  studentLastname: string;
  studentRut: string;
  type: 'tuition' | 'fee';
  paymentMethod: string;
  fileUrl: string;
  comment: string;
  validated: boolean;
  originalType?: 'tuition' | 'fee';
  originalPaymentMethod?: string;
};

export const translatePaymentType = (type: string): string => {
  const typeMap: { [key: string]: string } = {
    tuition: 'Matrícula',
    fee: 'Arancel',
  };
  return typeMap[type] || type;
};

export const translatePaymentMethod = (method: string): string => {
  const methodMap: { [key: string]: string } = {
    check: 'Cheque',
    monthly: 'Mensualidad',
    credit: 'Crédito',
    debit: 'Débito',
    transfer: 'Transferencia',
  };
  return methodMap[method] || method;
};
